import { Typography, useMediaQuery } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { ProfileUploadSection } from './ProfileUploadSection';
import { EnrollmentCard } from 'enrollment/features/Shared/EnrollmentCard';
import { InternalPage } from 'theSource/components';
import { ThemedHeader } from 'components/ThemedHeader';

export const ProfilePicture = () => {
  const { t } = useTranslation('pages.enrollmentDashboard');

  const ProfilePictureStates = useSelector(
    (state: any) => state?.enrollment?.chooseAvatar
  );

  const orientationDivider = useMediaQuery('(max-width: 569px)')
    ? 'horizontal'
    : 'vertical';

  return (
    <InternalPage
      testId="enrollment-profile-edit-page"
      id="enrollment-profile-edit-container"
    >
      <ThemedHeader cssClass="mb-5">{t('title')}</ThemedHeader>
      <Typography variant="body1" gutterBottom>
        {ProfilePictureStates?.avatar !== null
          ? t('description.postUpload')
          : t('description.preUpload')}
      </Typography>
      <EnrollmentCard navigateTo="profile">
        <ProfileUploadSection
          orientationDivider={orientationDivider}
          scope="subscriber"
          avatarFamilyDrawerScrollRef=""
        />
      </EnrollmentCard>
    </InternalPage>
  );
};
